let $body;
const cookieNotice = $('.Cookie-notice');
const cookieNoticeToggle = '.Cookie-notice__cta .Button';
let cookieNoticeCookie;

function setupCookieNotice() {
  cookieNoticeCookie = window.fpgmedia_js_params.home + '_cookie_notice_accept=1';

  const cookies = document.cookie;

  if (cookies.indexOf(cookieNoticeCookie) === -1 ) {
    cookieNotice.addClass('Cookie-notice--is-open');

    setTimeout(function() {
      cookieNotice.addClass('Cookie-notice--in');
    }, 500);
  }
}

function closeCookieNotice(e) {
  e.preventDefault();

  cookieNotice.removeClass('Cookie-notice--in');

  setTimeout(function() {
    cookieNotice.remove();
  }, 1000);

  document.cookie = cookieNoticeCookie + ';expires=Fri, 31 Dec 9999 23:59:59 GMT;path=/;SameSite=Lax';
}

export default function() {
  if (typeof window.Cookiebot !== 'undefined') {
    return;
  }

  setupCookieNotice();

  $body = $('body');
  $body.on('click', cookieNoticeToggle, closeCookieNotice);
}



// WEBPACK FOOTER //
// ./scripts/components/cookie-notice.js